import regexHelper from './regexHelper';

export default {
  install: (app) => {
    // Als globale Eigenschaft bereitstellen (für Options API)
    app.config.globalProperties.$regexHelper = regexHelper;
    
    // Als Provider bereitstellen (für Composition API - empfohlen)
    app.provide('regexHelper', regexHelper);
  }
} 